import { useState, useEffect, Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import "./MessageList.css";
import ModalMedia from "./ModalMedia";
import Loader from "../Components/Loader";
import renderMessage from "../Helper/renderMessage";
import { getMessageList as getMessageListLiveChat } from "../Store/Actions/LiveChatAction";

import {
  getAllMessageHistory,
  getMessageHistory,
  getMessageList,
  updateAgentRead,
} from "../Store/Actions/WABAAction";

function MessageList({
  chatListID,
  WAID,
  isLiveChat,
  isLiveChatWidget,
  isTyping,
  isAllHistoryShown,
  customerData,
}) {
  const [getDate, setGetDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [isModalMediaOpen, setIsModalMediaOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedMediaURL, setSelectedMediaURL] = useState("");
  const [total, setTotal] = useState(0);
  const { updateChat, updateChatSingle } = useSelector((state) => state.chat);
  let scrollTimer = null;

  useEffect(() => {
    const renderDateFLoat = () => {
      const messageBox = document.getElementById(
        "messageListInfiniteScrollTarget"
      );
      let dateFloat = document.getElementsByClassName("DateFloat");
      if (dateFloat.length > 0) dateFloat = dateFloat[0];
      const scrollEvent = (box) => {
        dateFloat.style.top = "0vh";
        dateFloat.style.opacity = 1;

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
          dateFloat.style.top = "-2vh";
          dateFloat.style.opacity = 0;
        }, 2000);

        const dateLabels = document.querySelectorAll(".DateSeparator");
        let currentLabel = null;
        let boxR = box.getBoundingClientRect();

        dateLabels.forEach((dateLabel, idx, arr) => {
          let dlR = dateLabel.getBoundingClientRect();
          if (dlR.top > boxR.top) {
            currentLabel = idx >= dateLabels.length ? arr[idx] : arr[idx + 1];
          } else if (idx === 0) {
            currentLabel = arr[idx];
          }
        });

        if (currentLabel) {
          let el = currentLabel.getElementsByClassName("DateSeparatorVal");
          if (el && el.length > 0) setGetDate(el[0].innerText);
        }
      };

      messageBox?.removeEventListener("scroll", () => {
        scrollEvent(messageBox);
      });

      messageBox?.addEventListener("scroll", () => {
        scrollEvent(messageBox);
      });
    };

    renderDateFLoat();
  }, []);

  // Effect ran when selected chat is changed
  useEffect(() => {
    if (isAllHistoryShown) {
      getAllMessageHistory(chatListID, WAID)
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("message history: ", response.data);

            setMessages(response.data);
            setGetDate(response.data[0]?.CreatedTime);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      fetchMessageList(true);
    }
  }, [chatListID]);

  // Effect ran when a new chat comes
  // Doesn't run when used in chat history
  useEffect(() => {
    !WAID && fetchMessageList(true, 1, true);
  }, [updateChat, updateChatSingle]);

  const fetchMessageList = (
    isFirstLoad,
    page,
    isUpdateChat // To check if called from effect
  ) => {
    if (isFirstLoad) {
      !isUpdateChat && setIsLoading(true);
      setPage(1);
    }

    if (isLiveChat) {
      getMessageListLiveChat(chatListID, page)
        .then((response) => {
          if (response.status) {
            if (isFirstLoad) {
              setMessages(response.data.messages);
              setGetDate(response.data.messages[0].CreatedTime);
            } else {
              setMessages([...messages, ...response.data.messages]);
            }

            setTotal(response.data.total);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    } else {
      getMessageList(chatListID, page)
        .then((response) => {
          if (response.status) {
            if (isFirstLoad) {
              setMessages(response.data.messages);
              setGetDate(response.data.messages[0].CreatedTime);
            } else {
              setMessages([...messages, ...response.data.messages]);
            }

            setTotal(response.data.total);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    }
  };

  const separator = (index, date, otherDate) => {
    if (
      index.toString() === "dateseparator" ||
      index.toString() === "datefloat"
    ) {
      let text = date;
      if (date === moment().format("DD MMM YYYY")) text = "Today";
      else if (date === moment().add(-1, "d").format("DD MMM YYYY"))
        text = "Yesterday";
      return date === otherDate ? (
        ""
      ) : (
        <div
          className={
            index.toString() === "dateseparator" ? "DateSeparator" : "DateFloat"
          }
        >
          <span>{text}</span>
          <span className="DateSeparatorVal" style={{ display: "none" }}>
            {date}
          </span>
        </div>
      );
    }
  };

  const statusSender = (status) => {
    let icon;

    switch (status) {
      case "sent":
        icon = "bi:check";
        break;

      case "NEW":
        icon = "mingcute:time-fill";
        break;

      case "delivered":
      case "read":
        icon = "bi:check-all";
        break;

      default:
        break;
    }

    return (
      <span className="message-status">
        {status === "failed" ? (
          "Failed"
        ) : (
          <Icon
            color={status === "read" ? "#0343C7" : "#727272"}
            height="18"
            icon={icon}
          />
        )}
      </span>
    );
  };

  function renderHandoverSeparator(currentMessage, messages, currentIndex) {
    if (isAllHistoryShown) {
      if (currentMessage?.HandoverStatus) {
        return (
          <div className="handover-separator">
            <hr />
            <p>{currentMessage?.HandoverStatus}</p>
            <hr />
          </div>
        );
      } else {
        return null;
      }
    } else {
      // don't show separator if current message is from customer
      if (currentMessage?.MessageFrom === "CUSTOMER") {
        return null;
      }

      // Find the previous agent message
      let previousAgentMessage = null;

      for (let i = currentIndex + 1; i < messages.length; i++) {
        if (
          messages[i].MessageFrom === "AGENT" ||
          messages[i].MessageFrom === "CHATBOT"
        ) {
          previousAgentMessage = messages[i];
          break;
        }
      }

      // Show chat room ID on start
      if (!previousAgentMessage) {
        return (
          <div className="handover-separator">
            <hr />

            <p>
              ChatRoom #WABA{currentMessage.ChatListID} with{" "}
              {currentMessage.AgentName ?? "Operator"}
            </p>

            <hr />
          </div>
        );
      } else if (
        // Show separator if agent changed
        previousAgentMessage?.AgentName !== currentMessage?.AgentName &&
        currentMessage?.Type !== "template"
      ) {
        return (
          <div className="handover-separator">
            <hr />

            <p>
              Handover to {currentMessage.AgentName ?? "Operator"} at{" "}
              {moment.utc(currentMessage.CreatedTime).format("HH:mm")}
            </p>

            <hr />
          </div>
        );
      }

      return null;
    }
  }

  return (
    <div className={`message-list ${isLiveChatWidget ? "is-live-chat" : ""}`}>
      <ModalMedia
        mediaURL={selectedMediaURL}
        open={isModalMediaOpen}
        source="WABA"
        onClose={() => {
          setSelectedMediaURL("");
          setIsModalMediaOpen(false);
        }}
      />

      {isLoading ? (
        <Loader />
      ) : messages.length ? (
        <div
          className="message-list-content infinite-scroll-target"
          id="messageListInfiniteScrollTarget"
        >
          {separator(
            "datefloat",
            moment.utc(getDate).format("DD MMM YYYY"),
            moment.utc(getDate).add(1, "d").format("DD MMM YYYY")
          )}

          <InfiniteScroll
            dataLength={messages.length}
            hasMore={messages.length < total}
            inverse
            loader={<Loader />}
            scrollableTarget="messageListInfiniteScrollTarget"
            scrollThreshold={0.5}
            style={{
              display: "flex",
              flexDirection: "column-reverse",
            }}
            next={() => {
              fetchMessageList(false, page + 1);
              setPage(page + 1);
            }}
          >
            {isTyping && (
              <Fragment>
                <div>
                  <div
                    className={`message-bubble-container ${
                      isLiveChatWidget ? "customer" : "agent"
                    } typing`}
                  >
                    <div className="message-bubble">
                      <Icon
                        icon="eos-icons:three-dots-loading"
                        width="40"
                        height="40"
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            )}

            {messages?.map((message, index, array) => {
              // Read message action
              if (
                message.MessageFrom === "CUSTOMER" &&
                !message.IsReadByAgent &&
                !isLiveChat
              ) {
                updateAgentRead({ wamid: message.WAMID })
                  .then((response) => {
                    if (response.status) {
                    } else {
                      console.log(
                        "Error read message ",
                        message.WAMID,
                        ": ",
                        response.error
                      );
                    }
                  })
                  .catch((err) => {
                    console.log(
                      "Error read message ",
                      message.WAMID,
                      ": ",
                      err
                    );
                  });
              }

              return (
                <Fragment key={message.MessageID}>
                  <div>
                    <div
                      className={`message-bubble-container ${
                        isLiveChatWidget
                          ? message.MessageFrom === "AGENT" ||
                            message.MessageFrom === "CHATBOT"
                            ? "customer"
                            : "agent"
                          : message.MessageFrom === "AGENT" ||
                            message.MessageFrom === "CHATBOT"
                          ? "agent"
                          : "customer"
                      }`}
                    >
                      <div className="message-bubble">
                        {(message.MessageFrom === "AGENT" ||
                          message.MessageFrom === "CHATBOT") && (
                          <span className="sender-name">
                            {message.MessageFrom === "AGENT"
                              ? message.AgentName
                              : "Operator"}
                          </span>
                        )}

                        {renderMessage(
                          message.BodyText,
                          message.Type,
                          message.MediaUrl,
                          message.TemplateName,
                          setIsModalMediaOpen,
                          setSelectedMediaURL,
                          {
                            address: message.LocationAddress,
                            latitude: message.LocationLatitude,
                            longitude: message.LocationLongitude,
                            name: message.LocationName,
                            url: message.LocationURL,
                          }
                        )}

                        <div className="message-info">
                          <span className="message-time">
                            {isLiveChat
                              ? moment(message.CreatedTime).format("HH:mm")
                              : moment.utc(message.CreatedTime).format("HH:mm")}
                          </span>

                          {(!isLiveChatWidget &&
                            message.MessageFrom === "AGENT") ||
                          (isLiveChatWidget &&
                            message.MessageFrom === "CUSTOMER")
                            ? statusSender(message.Status)
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  {renderHandoverSeparator(message, array, index)}

                  {separator(
                    "dateseparator",

                    isLiveChat
                      ? moment(message.CreatedTime).format("DD MMM YYYY")
                      : moment.utc(message.CreatedTime).format("DD MMM YYYY"),

                    index >= messages.length - 1
                      ? moment
                          .utc(message.CreatedTime)
                          .add(-1, "d")
                          .format("DD MMM YYYY")
                      : moment
                          .utc(array[index + 1].CreatedTime)
                          .format("DD MMM YYYY")
                  )}
                </Fragment>
              );
            })}
          </InfiniteScroll>
        </div>
      ) : (
        <p className="empty">No chat history found.</p>
      )}
    </div>
  );
}

export default MessageList;
